module.exports = __webpack_public_path__ + "media/images/icons/bi-activity-8d2627c3d210d4939b9510d61bb7f61d.png";